import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "input", "oddDisplay", "potentialDisplay", "amountDisplay", "amountValue", "submit"]
  static values = { totalPool: Number, feeRate: Number }

  connect() {
    this.cents = 0
  }

  select(event) {
    const outcomeId = event.currentTarget.dataset.outcomeId

    this.inputTarget.value = outcomeId

    this.optionTargets.forEach(opt => {
      opt.classList.toggle("outcome-option--selected", opt.dataset.outcomeId === outcomeId)
    })

    this.updateProjection()
    this.updateSubmit()
  }

  formatAmount(event) {
    const raw = event.target.value.replace(/\D/g, "")
    this.cents = parseInt(raw, 10) || 0
    event.target.value = this.formatCents(this.cents)
    this.amountValueTarget.value = this.cents
    this.updateProjection()
    this.updateSubmit()
  }

  preventInvalidKey(event) {
    if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"].includes(event.key)) return
    if (!/^\d$/.test(event.key)) event.preventDefault()
  }

  addAmount(event) {
    event.preventDefault()
    const reais = parseInt(event.currentTarget.dataset.amount, 10) || 0
    this.cents += reais * 100
    this.amountDisplayTarget.value = this.formatCents(this.cents)
    this.amountValueTarget.value = this.cents
    this.updateProjection()
    this.updateSubmit()
  }

  updateProjection() {
    if (!this.hasPotentialDisplayTarget) return
    const selected = this.optionTargets.find(o => o.classList.contains("outcome-option--selected"))
    if (!selected || this.cents === 0) {
      this.oddDisplayTarget.textContent = selected ? `${parseFloat(selected.dataset.odd).toFixed(2)}x` : "—"
      this.potentialDisplayTarget.textContent = "—"
      return
    }

    const outcomePoolCents = parseInt(selected.dataset.poolCents, 10) || 0
    const totalPoolCents = this.totalPoolValue || 0
    const feeRate = this.feeRateValue || 0.05

    // Pool projetado APÓS a aposta do usuário entrar
    const newOutcomePool = outcomePoolCents + this.cents
    const newTotalPool = totalPoolCents + this.cents

    // Odd projetada: (total_pool / outcome_pool) * (1 - fee)
    const projectedOdd = (newTotalPool / newOutcomePool) * (1 - feeRate)

    // Retorno potencial em centavos, convertido para reais
    const potentialCents = Math.round(this.cents * projectedOdd)
    const potentialReais = (potentialCents / 100).toFixed(2)

    this.oddDisplayTarget.textContent = `${projectedOdd.toFixed(2)}x`
    this.potentialDisplayTarget.textContent = `R$ ${potentialReais.replace(".", ",")}`
    this.updateSubmit()
  }

  updateSubmit() {
    if (!this.hasSubmitTarget) return
    const hasOutcome = this.inputTarget.value !== ""
    this.submitTarget.disabled = !hasOutcome
  }

  formatCents(cents) {
    if (cents === 0) return ""
    const reais = Math.floor(cents / 100)
    const centavos = cents % 100
    const reaisStr = reais.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    return `${reaisStr},${centavos.toString().padStart(2, "0")}`
  }
}
